__turbopack_context__.v({
  "authorInfo": "ProductReviews-module__6Scqoq__authorInfo",
  "authorName": "ProductReviews-module__6Scqoq__authorName",
  "avatar": "ProductReviews-module__6Scqoq__avatar",
  "breakdown": "ProductReviews-module__6Scqoq__breakdown",
  "breakdownCount": "ProductReviews-module__6Scqoq__breakdownCount",
  "breakdownLabel": "ProductReviews-module__6Scqoq__breakdownLabel",
  "breakdownRow": "ProductReviews-module__6Scqoq__breakdownRow",
  "categories": "ProductReviews-module__6Scqoq__categories",
  "categoryName": "ProductReviews-module__6Scqoq__categoryName",
  "categoryRating": "ProductReviews-module__6Scqoq__categoryRating",
  "categoryTag": "ProductReviews-module__6Scqoq__categoryTag",
  "content": "ProductReviews-module__6Scqoq__content",
  "overallRating": "ProductReviews-module__6Scqoq__overallRating",
  "progressBar": "ProductReviews-module__6Scqoq__progressBar",
  "progressFill": "ProductReviews-module__6Scqoq__progressFill",
  "ratingNumber": "ProductReviews-module__6Scqoq__ratingNumber",
  "ratingValue": "ProductReviews-module__6Scqoq__ratingValue",
  "reviewCard": "ProductReviews-module__6Scqoq__reviewCard",
  "reviewDate": "ProductReviews-module__6Scqoq__reviewDate",
  "reviewHeader": "ProductReviews-module__6Scqoq__reviewHeader",
  "reviewImage": "ProductReviews-module__6Scqoq__reviewImage",
  "reviewImages": "ProductReviews-module__6Scqoq__reviewImages",
  "reviewRating": "ProductReviews-module__6Scqoq__reviewRating",
  "reviewStars": "ProductReviews-module__6Scqoq__reviewStars",
  "reviewText": "ProductReviews-module__6Scqoq__reviewText",
  "reviewsList": "ProductReviews-module__6Scqoq__reviewsList",
  "reviewsSection": "ProductReviews-module__6Scqoq__reviewsSection",
  "showMoreBtn": "ProductReviews-module__6Scqoq__showMoreBtn",
  "starEmpty": "ProductReviews-module__6Scqoq__starEmpty",
  "starFilled": "ProductReviews-module__6Scqoq__starFilled",
  "stars": "ProductReviews-module__6Scqoq__stars",
  "statsCard": "ProductReviews-module__6Scqoq__statsCard",
  "title": "ProductReviews-module__6Scqoq__title",
  "totalReviews": "ProductReviews-module__6Scqoq__totalReviews",
});
